import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { ConvertService } from 'src/app/services/convert.service';
import { GENDERS, DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ITrainingStudent, ITrainingTutor } from 'src/app/interfaces/training';
import { TrainingStore } from 'src/app/stores/training/training.store';
import { FireStorageService } from 'src/app/services/fire-storage.service';

@Component({
  selector: 'app-add-training-tutor',
  templateUrl: './add-training-tutor.component.html',
  styleUrls: ['./add-training-tutor.component.scss']
})
export class AddTrainingTutorComponent implements OnInit {
  @ViewChild('focusInput', { static: false }) inputEl: ElementRef;
  @ViewChild('photoFile', { static: false }) photoFile: ElementRef;

  form: FormGroup;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;
  TITLE = 'Add new tutor';
  GENDER: any = GENDERS;
  ITEM: ITrainingTutor;
  START_UPLOAD: boolean;
  uploadPercent: any;
  SELECTED_PICTURE_FILE: any;
  imageSrc: string;

  constructor(
    public dialogRef: MatDialogRef<AddTrainingTutorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: TrainingStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private storage: FireStorageService,
  ) { }

  ngOnInit() {
    const { ITEM } = this.data;
    this.ITEM = ITEM || null;
    this.form = this.fb.group({
      firstName: [ITEM ? ITEM.firstName : null, Validators.compose([Validators.required])],
      lastName: [ITEM ? ITEM.lastName : null, Validators.compose([Validators.required])],
      gender: [ITEM ? ITEM.gender : GENDERS[0], Validators.compose([Validators.required])],
      dateOfBirth: [ITEM ? ITEM.dateOfBirth.toDate() : new Date(), Validators.compose([Validators.required])],
      phoneNumber: [ITEM ? ITEM.phoneNumber : null, Validators.compose([Validators.required])],
      email: [ITEM ? ITEM.email : null,],

    })
    if (ITEM) {
      this.TITLE = "Edit tutor";
    }
  }

  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }


  async uploadFilePicture(event) {
    if (event && event.target.files.length > 0) {
      this.SELECTED_PICTURE_FILE = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageSrc = e.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
      if (this.ITEM) {
        //PICTURE
        this.START_UPLOAD = true;
        const file = this.SELECTED_PICTURE_FILE;
        const fileName = file.name;
        const uploadPath = `tutors/${this.ITEM.key}/${fileName}`;
        const uploadTask = this.storage.uploadSelectedFile(file, uploadPath);
        this.uploadPercent = uploadTask.percentageChanges();
        const files = await this.storage.getFileDetail(file, uploadPath, uploadTask)
        this.ITEM.photoFileDetail = files;
        this.store.addTutor(this.ITEM, (success, res) => {
          if (success) {
            this.snackBar.open("Tutor has been saved successful.", "Done", { duration: 2500 });
          }
          this.processNew = false;
          this.processClose = false;
          this.SELECTED_PICTURE_FILE = null;
          this.START_UPLOAD = false;
          this.imageSrc = null;
          this.photoFile.nativeElement.value = "";
        })
      }
    }
  }


  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    this.isCreate = true;
    if (this.form.valid) {
      this.form.disable();
      const { firstName, lastName, phoneNumber, dateOfBirth, email, gender } = f;
      const { ITEM } = this.data;
      const { user, selectedCompanyKey } = this.auth;
      const registerStatus = STATUS_OBJECT.submitted;
      const item: ITrainingTutor = {
        key: ITEM ? ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${firstName} ${lastName} ${phoneNumber} ${email}`),
        organizationRef: selectedCompanyKey ? this.ds.companyRef().doc(selectedCompanyKey).ref : null,
        organizationKey: selectedCompanyKey || null,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        dateOfBirth,
        firstName,
        lastName,
        fullName: `${firstName} ${lastName}`,
        email,
        phoneNumber,
        gender: gender,
      }
      if (this.SELECTED_PICTURE_FILE) {
        this.START_UPLOAD = true;
        const file = this.SELECTED_PICTURE_FILE;
        const fileName = file.name;
        const uploadPath = `tutors/${item.key}/${fileName}`;
        const uploadTask = this.storage.uploadSelectedFile(file, uploadPath);
        this.uploadPercent = uploadTask.percentageChanges();
        const files = await this.storage.getFileDetail(file, uploadPath, uploadTask)
        item.photoFileDetail = files;
        this.START_UPLOAD = false;
      }
      this.store.addTutor(item, (success, res) => {
        if (success) {
          this.snackBar.open("Tutor has been saved successful.", "Done", { duration: 1000 });
          if (!isNew) {
            this.dialogRef.close('no')
            return;
          }
          this.form.reset();
          this.form.enable();
          this.processNew = false;
          this.processClose = false;
          this.isCreate = false;
          this.SELECTED_PICTURE_FILE = null;
          this.imageSrc = null;
          this.photoFile.nativeElement.value = "";
          this.inputEl.nativeElement.focus()
        }

      })
    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }
}